
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as loginQCB_45he1kDChZPUlhqjKWJPig2wCE8BJQPhQF8eBraE4Meta } from "/var/www/share/mysofabed.de/app/pages/login.vue?macro=true";
import { default as search9SBbfVq1i1QZaNgIL7dOZi2Woi6tTyzGxM8eI8PiwvwMeta } from "/var/www/share/mysofabed.de/app/pages/search.vue?macro=true";
import { default as _91_46_46_46all_93Qdq4d6faiTOT5Dd9vXL8fYju2_pzzislH8Zuo8Jy_45LQMeta } from "/var/www/share/mysofabed.de/app/pages/[...all].vue?macro=true";
import { default as register6HTzLCP_45mUbH07ZTL5Jw2UjIvnQRP8iT0YUJcDRQAcUMeta } from "/var/www/share/mysofabed.de/app/pages/register.vue?macro=true";
import { default as wishlist8KoKakPdrcalUS2cqwWcFlCTQ5EUhr_45XbxNa83zFbpMMeta } from "/var/www/share/mysofabed.de/app/pages/wishlist.vue?macro=true";
import { default as cache_45testbuczVGeUGMqABX7s8Mx2Waxq9qJHNCSNcQuE7BFsy_YMeta } from "/var/www/share/mysofabed.de/app/pages/cache-test.vue?macro=true";
import { default as indeximPJa5au2GihSbdESxX6BeZZyUPeMIScck1_45He2Qb_45IMeta } from "/var/www/share/mysofabed.de/app/pages/account/index.vue?macro=true";
import { default as cartXk3IzKLqGi5NPMWldvUSk5j3sZ8KfMccsGESnQUlbgEMeta } from "/var/www/share/mysofabed.de/app/pages/checkout/cart.vue?macro=true";
import { default as indexbFHtoiTTtv1O9OltHROcWpXatPvpeyxaAs98wfZppMsMeta } from "/var/www/share/mysofabed.de/app/pages/checkout/index.vue?macro=true";
import { default as reset_45password9U0bdKIB4ggXWGM_tryuHVBY_N2jwqlFyI9a1tLa9wsMeta } from "/var/www/share/mysofabed.de/app/pages/reset-password.vue?macro=true";
import { default as addressLeUhJxKENakFkfUiV3XPi5K6pa0jRpONJ13FgdUrzgAMeta } from "/var/www/share/mysofabed.de/app/pages/account/address.vue?macro=true";
import { default as profile1XW7f2SjWuH3T_f0qR_45ODa6vdy_DL0EMuWc7vpOb1JAMeta } from "/var/www/share/mysofabed.de/app/pages/account/profile.vue?macro=true";
import { default as indexm7HM8RtjqCp5zbdiScMwanBC9MKYrh8Su38IB32Q_45K8Meta } from "/var/www/share/mysofabed.de/app/pages/account/order/index.vue?macro=true";
import { default as newsletter_45subscribe8j0Ie75W5Acwd6_457HKSjq29pnW_XGz1Nj63pdAHSB9AMeta } from "/var/www/share/mysofabed.de/app/pages/newsletter-subscribe.vue?macro=true";
import { default as confirmBPAKOUOtMori8SPTzRkwxSnUjjS0_Jz3LgmOyNtmdE8Meta } from "/var/www/share/mysofabed.de/app/pages/registration/confirm.vue?macro=true";
import { default as indexDyDWArlFWI00ALrunt6Ix5teVZ24S3goq_FCK5KX0LAMeta } from "/var/www/share/mysofabed.de/app/pages/account/recover/index.vue?macro=true";
import { default as passwordChtYg_45DLHXCCy4iCdoUUGE7Pf2PBIsEBaLJ6WHwHON4Meta } from "/var/www/share/mysofabed.de/app/pages/account/recover/password.vue?macro=true";
import { default as callbackBxvMx_IBUqR9foXaaTAqtkmlvUbe6B1AoyTjcYP_jUMMeta } from "/var/www/share/mysofabed.de/app/pages/checkout/paypal/callback.vue?macro=true";
import { default as _91id_93Hg_45T7SVm8fSEWNdiK3jjrdlhXuo4fp9KkKy9TbtaL_45sMeta } from "/var/www/share/mysofabed.de/app/pages/account/order/details/[id].vue?macro=true";
import { default as paiduPCu9cOCqEdDeyuNNrbkqstSIUlk0oJtzkFOx3CG8EUMeta } from "/var/www/share/mysofabed.de/app/pages/checkout/success/[id]/paid.vue?macro=true";
import { default as indexM7iWpTyAx1mk_45m8joIKUO17_45PgVZlkzgZLfRKc8_90AMeta } from "/var/www/share/mysofabed.de/app/pages/checkout/success/[id]/index.vue?macro=true";
import { default as unpaidGSJffzmG_mMnzUJBG2Z_45Suyvho20d84KUyVeeTuR3_45gMeta } from "/var/www/share/mysofabed.de/app/pages/checkout/success/[id]/unpaid.vue?macro=true";
import { default as component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta } from "/var/www/share/mysofabed.de/app/node_modules/.pnpm/nuxt@3.17.5_@biomejs+biome@1.8.3_@parcel+watcher@2.5.1_@types+node@22.15.23_db0@0.3.2_e_da87fc9f9e0427cb820d26493b88beaa/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ } from "/var/www/share/mysofabed.de/app/node_modules/.pnpm/nuxt@3.17.5_@biomejs+biome@1.8.3_@parcel+watcher@2.5.1_@types+node@22.15.23_db0@0.3.2_e_da87fc9f9e0427cb820d26493b88beaa/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "login___en-GB",
    path: "/en-GB/login",
    component: () => import("/var/www/share/mysofabed.de/app/pages/login.vue")
  },
  {
    name: "login___de-DE",
    path: "/login",
    component: () => import("/var/www/share/mysofabed.de/app/pages/login.vue")
  },
  {
    name: "search___en-GB",
    path: "/en-GB/search",
    component: () => import("/var/www/share/mysofabed.de/app/pages/search.vue")
  },
  {
    name: "search___de-DE",
    path: "/search",
    component: () => import("/var/www/share/mysofabed.de/app/pages/search.vue")
  },
  {
    name: "all___en-GB",
    path: "/en-GB/:all(.*)*",
    component: () => import("/var/www/share/mysofabed.de/app/pages/[...all].vue")
  },
  {
    name: "all___de-DE",
    path: "/:all(.*)*",
    component: () => import("/var/www/share/mysofabed.de/app/pages/[...all].vue")
  },
  {
    name: "register___en-GB",
    path: "/en-GB/register",
    component: () => import("/var/www/share/mysofabed.de/app/pages/register.vue")
  },
  {
    name: "register___de-DE",
    path: "/register",
    component: () => import("/var/www/share/mysofabed.de/app/pages/register.vue")
  },
  {
    name: "wishlist___en-GB",
    path: "/en-GB/wishlist",
    component: () => import("/var/www/share/mysofabed.de/app/pages/wishlist.vue")
  },
  {
    name: "wishlist___de-DE",
    path: "/wishlist",
    component: () => import("/var/www/share/mysofabed.de/app/pages/wishlist.vue")
  },
  {
    name: "cache-test___en-GB",
    path: "/en-GB/cache-test",
    component: () => import("/var/www/share/mysofabed.de/app/pages/cache-test.vue")
  },
  {
    name: "cache-test___de-DE",
    path: "/cache-test",
    component: () => import("/var/www/share/mysofabed.de/app/pages/cache-test.vue")
  },
  {
    name: "account___en-GB",
    path: "/en-GB/account",
    meta: indeximPJa5au2GihSbdESxX6BeZZyUPeMIScck1_45He2Qb_45IMeta || {},
    component: () => import("/var/www/share/mysofabed.de/app/pages/account/index.vue")
  },
  {
    name: "account___de-DE",
    path: "/account",
    meta: indeximPJa5au2GihSbdESxX6BeZZyUPeMIScck1_45He2Qb_45IMeta || {},
    component: () => import("/var/www/share/mysofabed.de/app/pages/account/index.vue")
  },
  {
    name: "checkout-cart___en-GB",
    path: "/en-GB/checkout/cart",
    meta: cartXk3IzKLqGi5NPMWldvUSk5j3sZ8KfMccsGESnQUlbgEMeta || {},
    component: () => import("/var/www/share/mysofabed.de/app/pages/checkout/cart.vue")
  },
  {
    name: "checkout-cart___de-DE",
    path: "/checkout/cart",
    meta: cartXk3IzKLqGi5NPMWldvUSk5j3sZ8KfMccsGESnQUlbgEMeta || {},
    component: () => import("/var/www/share/mysofabed.de/app/pages/checkout/cart.vue")
  },
  {
    name: "checkout___en-GB",
    path: "/en-GB/checkout",
    meta: indexbFHtoiTTtv1O9OltHROcWpXatPvpeyxaAs98wfZppMsMeta || {},
    component: () => import("/var/www/share/mysofabed.de/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___de-DE",
    path: "/checkout",
    meta: indexbFHtoiTTtv1O9OltHROcWpXatPvpeyxaAs98wfZppMsMeta || {},
    component: () => import("/var/www/share/mysofabed.de/app/pages/checkout/index.vue")
  },
  {
    name: "reset-password___en-GB",
    path: "/en-GB/reset-password",
    component: () => import("/var/www/share/mysofabed.de/app/pages/reset-password.vue")
  },
  {
    name: "reset-password___de-DE",
    path: "/reset-password",
    component: () => import("/var/www/share/mysofabed.de/app/pages/reset-password.vue")
  },
  {
    name: "account-address___en-GB",
    path: "/en-GB/account/address",
    meta: addressLeUhJxKENakFkfUiV3XPi5K6pa0jRpONJ13FgdUrzgAMeta || {},
    component: () => import("/var/www/share/mysofabed.de/app/pages/account/address.vue")
  },
  {
    name: "account-address___de-DE",
    path: "/account/address",
    meta: addressLeUhJxKENakFkfUiV3XPi5K6pa0jRpONJ13FgdUrzgAMeta || {},
    component: () => import("/var/www/share/mysofabed.de/app/pages/account/address.vue")
  },
  {
    name: "account-profile___en-GB",
    path: "/en-GB/account/profile",
    meta: profile1XW7f2SjWuH3T_f0qR_45ODa6vdy_DL0EMuWc7vpOb1JAMeta || {},
    component: () => import("/var/www/share/mysofabed.de/app/pages/account/profile.vue")
  },
  {
    name: "account-profile___de-DE",
    path: "/account/profile",
    meta: profile1XW7f2SjWuH3T_f0qR_45ODa6vdy_DL0EMuWc7vpOb1JAMeta || {},
    component: () => import("/var/www/share/mysofabed.de/app/pages/account/profile.vue")
  },
  {
    name: "account-order___en-GB",
    path: "/en-GB/account/order",
    meta: indexm7HM8RtjqCp5zbdiScMwanBC9MKYrh8Su38IB32Q_45K8Meta || {},
    component: () => import("/var/www/share/mysofabed.de/app/pages/account/order/index.vue")
  },
  {
    name: "account-order___de-DE",
    path: "/account/order",
    meta: indexm7HM8RtjqCp5zbdiScMwanBC9MKYrh8Su38IB32Q_45K8Meta || {},
    component: () => import("/var/www/share/mysofabed.de/app/pages/account/order/index.vue")
  },
  {
    name: "newsletter-subscribe___en-GB",
    path: "/en-GB/newsletter-subscribe",
    component: () => import("/var/www/share/mysofabed.de/app/pages/newsletter-subscribe.vue")
  },
  {
    name: "newsletter-subscribe___de-DE",
    path: "/newsletter-subscribe",
    component: () => import("/var/www/share/mysofabed.de/app/pages/newsletter-subscribe.vue")
  },
  {
    name: "registration-confirm___en-GB",
    path: "/en-GB/registration/confirm",
    component: () => import("/var/www/share/mysofabed.de/app/pages/registration/confirm.vue")
  },
  {
    name: "registration-confirm___de-DE",
    path: "/registration/confirm",
    component: () => import("/var/www/share/mysofabed.de/app/pages/registration/confirm.vue")
  },
  {
    name: "account-recover___en-GB",
    path: "/en-GB/account/recover",
    component: () => import("/var/www/share/mysofabed.de/app/pages/account/recover/index.vue")
  },
  {
    name: "account-recover___de-DE",
    path: "/account/recover",
    component: () => import("/var/www/share/mysofabed.de/app/pages/account/recover/index.vue")
  },
  {
    name: "account-recover-password___en-GB",
    path: "/en-GB/account/recover/password",
    component: () => import("/var/www/share/mysofabed.de/app/pages/account/recover/password.vue")
  },
  {
    name: "account-recover-password___de-DE",
    path: "/account/recover/password",
    component: () => import("/var/www/share/mysofabed.de/app/pages/account/recover/password.vue")
  },
  {
    name: "checkout-paypal-callback___en-GB",
    path: "/en-GB/checkout/paypal/callback",
    component: () => import("/var/www/share/mysofabed.de/app/pages/checkout/paypal/callback.vue")
  },
  {
    name: "checkout-paypal-callback___de-DE",
    path: "/checkout/paypal/callback",
    component: () => import("/var/www/share/mysofabed.de/app/pages/checkout/paypal/callback.vue")
  },
  {
    name: "account-order-details-id___en-GB",
    path: "/en-GB/account/order/details/:id()",
    meta: _91id_93Hg_45T7SVm8fSEWNdiK3jjrdlhXuo4fp9KkKy9TbtaL_45sMeta || {},
    component: () => import("/var/www/share/mysofabed.de/app/pages/account/order/details/[id].vue")
  },
  {
    name: "account-order-details-id___de-DE",
    path: "/account/order/details/:id()",
    meta: _91id_93Hg_45T7SVm8fSEWNdiK3jjrdlhXuo4fp9KkKy9TbtaL_45sMeta || {},
    component: () => import("/var/www/share/mysofabed.de/app/pages/account/order/details/[id].vue")
  },
  {
    name: "checkout-success-id-paid___en-GB",
    path: "/en-GB/checkout/success/:id()/paid",
    component: () => import("/var/www/share/mysofabed.de/app/pages/checkout/success/[id]/paid.vue")
  },
  {
    name: "checkout-success-id-paid___de-DE",
    path: "/checkout/success/:id()/paid",
    component: () => import("/var/www/share/mysofabed.de/app/pages/checkout/success/[id]/paid.vue")
  },
  {
    name: "checkout-success-id___en-GB",
    path: "/en-GB/checkout/success/:id()",
    component: () => import("/var/www/share/mysofabed.de/app/pages/checkout/success/[id]/index.vue")
  },
  {
    name: "checkout-success-id___de-DE",
    path: "/checkout/success/:id()",
    component: () => import("/var/www/share/mysofabed.de/app/pages/checkout/success/[id]/index.vue")
  },
  {
    name: "checkout-success-id-unpaid___en-GB",
    path: "/en-GB/checkout/success/:id()/unpaid",
    component: () => import("/var/www/share/mysofabed.de/app/pages/checkout/success/[id]/unpaid.vue")
  },
  {
    name: "checkout-success-id-unpaid___de-DE",
    path: "/checkout/success/:id()/unpaid",
    component: () => import("/var/www/share/mysofabed.de/app/pages/checkout/success/[id]/unpaid.vue")
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/cozypad-schlafsofa",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/cozypad-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/specials.php",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/create_guest_account.php",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-be/florida-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/detail/index/sArticle/52",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/lotus-passion-ohio-eckelement-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/lotus-passion-ohio-einzelelement-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/lotus-passion-ohio-hocker-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/lotus-passion-ohio-hocker-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/helsinki-2-5-sitzer-designer-sofa-mit-polsterarmlehnen-und-seitenkissen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/helsinki-2-sitzer-designer-sofa-mit-polsterarmlehnen-und-seitenkissen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/helsinki-designer-sessel-mit-polsterarmlehnen-und-seitenkissen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/helsinki-3-sitzer-designer-sofa-mit-polsterarmlehnen-und-seitenkissen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/sofa",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/sofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/boston-schlafsofa-mit-lattenrost-und-matratze",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/innovation-zubehoer/zap-armlehnen-fuer-schlafsofa-modelle-skater-und-fuji-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/thyra-schlafhocker-gaestebett-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/masica-bigsofa-mit-armlehnen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/recast-sessel-mit-kissen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/svala-von-innovation-schlafsofa-mit-bettkasten",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/puzzle-wood-klappsofa-von-innovation-diverse-farben",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/puzzle-wood-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/tripleback-schlafsofa-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/tripleback-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/radar-relaxsessel-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/radar-designersessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/rio-designer-sessel-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/rio-loungesessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/heart-modulsofa-mit-schlaffunktion-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/heart-modulsofa-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/heart-tablett-von-softline-auflage-aus-acryl-in-milchglas",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/texas-schlafsofa-bettsofa-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-be/texas-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/mit-gaestebettfunktion/loop-schlafsessel-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/loop-schlafsofa-und-sessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/loop-schlafsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/eckschlafsofa/mit-gaestebettfunktion/malou-set-eckschlafsofa-mit-bettkasten-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/mit-gaestebettfunktion/malou-schlafsessel-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/fiore-schlafsofa-mit-matratze-und-klappfunktion-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/fiore-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/cubismo-schlafsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/cubismo-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/luino-schlafsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/luino-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/gianni-schlafsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/gianni-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/costa-schlafsofa-mit-bettkasten-und-stauraumbox-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/costa-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/scene-schlafsofa-bigsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/scene-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/milan-schlafsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/milan-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/modulsofa-bigsofa/cocco-ecksofa-mit-bettfunktion-und-bettkasten-von-franz-fertig",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/cocco-ecksofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/modulsofa-bigsofa/corali-ecksofa-mit-bettfunktion-und-schwenksitz-von-franz-fertig",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/corali-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/zero-schlafsofa-mit-klappbaren-armlehnen-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/zero-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/fun-schlafsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/fun-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/twinset-schlafsofa-liege-gaestebett-von-franz-fertig",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/eckschlafsofa/mit-gaestebettfunktion/twinset-ecksofa-mit-schlaffunktion-von-franz-fertig",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/twinset-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/coin-schlafsofa-mit-bettkasten-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/coin-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/celebrity-schlafsofa-bettsofa-mit-klappfunktion-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/celebrity-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/giacomo-schlafsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/giacomo-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/livo-schlafsofa-von-franz-fertig",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/livo-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/eckschlafsofa/mit-gaestebettfunktion/livo-soft-eckschlafsofa-mit-bettkasten-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/livo-soft-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/blu-schlafsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/mit-gaestebettfunktion/blu-schlafsessel-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/blu-schlafsofa-und-schlafsessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/mit-gaestebettfunktion/fox-schlafsessel-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/fox-schlafsessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/pia-designersessel-mit-polsterarmlehnen-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/pia-hocker-von-franz-fertig-mit-grosser-stoff-und-lederauswahl",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/pia-sessel-und-hocker/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/debonair-schlafsofa-mit-rollen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/debonair-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/eckschlafsofa/mit-gaestebettfunktion/fiftynine-schlafsofa-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/eckschlafsofa/mit-gaestebettfunktion/fiftynine-schlafsessel-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/fiftynine-schlafsofa-und-sessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/innovation-zubehoer/ersatzbezug-innovation-fuer-querschlaefer-ohne-gestellbezug-round-style",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/elektro-schlafsofa-elektrisch-ausfahrbar",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-be/elektro-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/chicago-schlafsofa-mit-lattenrost-und-matratze-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/eckschlafsofa/mit-bett-fuer-jeden-tag/chicago-eckschlafsofa-mit-lattenrost-und-bettkasten-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-be/chicago-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/washington-schlafsofa-mit-lattenrost-und-matratze",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-be/washington-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/san-francisco-schlafsofa-mit-lattenrost-und-matratze-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-be/san-francisco-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/detroit-schlafsofa-mit-lattenrost-und-matratze-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-be/detroit-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/new-jersey-schlafsofa-mit-lattenrost-und-matratze-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-be/new-jersey-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/philadelphia-schlafsofa-bettsofa-mit-lattenrost-und-matratze-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-be/philadelphia-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/kansas-schlafsofa-mit-lattenrost-und-matratze-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/kansas-ecksofa-mit-schlaffunktion-und-bettkasten-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-be/kansas-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/virginia-schlafsofa-mit-lattenrost-und-matratze-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/mit-bett-fuer-jeden-tag/virginia-schlafsessel-mit-lattenrost-und-matratze-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-be/virginia-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/matratzen-fuer-schlafsofas/matratzen-fuer-schlafsofas-federkern-oder-taschenfederkern-mit-latex-in-div.-groessen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/muenster-deluxe-schlafsofa-und-tagesliege-mit-lattenrost-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-de/muenster-deluxe-daybed/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/lund-designer-sessel-mit-polsterarmlehnen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/lund-hocker-mit-grosser-stoffauswahl",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/myk-schlafsofa-daybed-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/myk-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/matratzen-fuer-schlafsofas/gelformtopper-dick-matratzenauflage-in-diversen-groessen-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/all-you-need-daybed/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/all-you-need-schlafsofa-daybed-von-innovation-100x200cm",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/filuca-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/filuca-daybed-mit-teilbaren-liegeflaechen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/puzzle-cubic-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/puzzle-cubic-von-innovation-schlafsofa-mit-klappbarer-rueckenlehne",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/ghia-haylo-sofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/ghia-haylo-daybed-schlafsofa-liege-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/villum-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/villum-schlafsofa-von-innovation-mit-trennbaren-liegeflaechen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/linna-daybed/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/linna-daybed-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/ronia-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/frigga-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/vidar-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/cosy-ohrensessel-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/cosy-relax-und-ohrensessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/cosy-ohrensessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/angel-sessel-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/angel-lounge-sessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/angel-designer-sessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/scope-lounge-sofa-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/scope-designer-sofa-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/scope-designer-sessel-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/scope-lounge-sessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/scope-lounge-sofa-und-sessel",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/shelly-sessel-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/shelly-drehsessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/shelly-designer-sessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/venice-loungesessel-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/venice-sessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/venice-loungesessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/hugo-sessel-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/hugo-sessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/hugo-sessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/orlando-drehsessel-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/orlando-drehstuhl-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/orlando-designersessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/sitt-sitzsack-von-softline-indoor-outdoor",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/sitt-sitzsack-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/sitt-sitzsack/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/magnum-sitzsack-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/magnum-sitzsack-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/magnum-sitzsack/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/chat-sofa-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/chat-sofa-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/chat-designersessel-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/chat-sessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/chat-hocker-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/chat-hocker-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/chat-designersofa-sessel-hocker/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/havana-low-sessel-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/havana-low-sessel-chair-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/venus-schlafsofa-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/venus-schlafsofa-von-softline-mit-den-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/venus-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/victor-schlafsofa-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/victor-schlafcouch-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/victor-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/liegen-und-daybeds/mit-gaestebettfunktion/max-schlafhocker-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/liegen-und-daybeds/mit-gaestebettfunktion/max-schlafhocker-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/max-schlafhocker/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/metro-schlafsofa-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/metro-schlafsofa-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/metro-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/jasper-schlafsofa-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/jasper-sofa-mit-schlaffunktion-von-softline-in-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/jasper-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/lazy-schlafsofa-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/lazy-klappsofa-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/lazy-schlafcouch/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/planet-modulsofa-bigsofa-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/planet-modulsofa-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/planet-modulsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/pod-sitzhocker-container-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/pod-sitzhocker-container-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/pod-sitzhocker-mit-stauraum/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/aiko-aiko-swivel-dining-sessel-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/aiko-aiko-swivel-dining-sessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/aiko-und-aiko-swivel-designer-sessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/coco-coco-swivel-sessel-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/coco-coco-swivel-sessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/coco-und-coco-swivel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/groove-sessel-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/groove-sessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/groove-designer-sessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/detail/index/sArticle/132/sCategory/174",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/detail/index/sArticle/133/sCategory/174",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/cat/index/sCategory/174",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/hello-designer-sessel-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/hello-sessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/hello-designersessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/couchtische/hello-couchtisch-beistelltisch-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/coral-sitzhocker-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/coral-sitzhocker-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/coral-sitzhocker/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/lisbon-sitzhocker-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/lisbon-pouf-/-hocker-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/lisbon-sitzhocker/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/fluid-sitzsack-sofa-von-softline-indoor-outdoor",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/fluid-sitzsack-loungesofa-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/fluid-sitzsack-sessel-von-softline-indoor-outdoor",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/fluid-sitzsack-sessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/fluid-sitzsackmoebel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/easy-liege-von-softline-indoor-outdoor",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/easy-liege-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/easy-liege-und-outdoorliege/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/pause-hocker-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/pause-hocker-pouf-von-softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/pause-designer-sitzhocker/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/bingo-faltmatratze-hocker-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/faltmatratzen/handy-faltmatratze-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/trio-faltmatratze-hocker-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/kissen/milan-kissen-45x45-cm-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/kissen/swing-kissen-60x60-cm-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/pouf-wuerfel-hocker-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/space-hocker-beistelltisch-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/alma-hocker-beistelltisch-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/apollo-sessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/bon-bon-hocker-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/grand-prix-sessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/quadro-sitzhocker-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/nector-hocker-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/softsquare-sitzwuerfel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/liegen-und-daybeds/liegen-ohne-funktion/sense-liege-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/madison-schlafsofa-von-softline-mit-den-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/meghan-schlafsofa-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/mit-gaestebettfunktion/cord-klappsessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/cord-sofa-mit-klappfunktion-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/lounge-plus-sofa-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/lounge-plus-schlafhocker-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/mit-gaestebettfunktion/city-klappsessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/city-klappsofa-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/mit-gaestebettfunktion/silver-schlafsessel-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/silver-schlafsofa-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/loft-modulsofa-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/noa-modulsofa-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/frame-daybed-schlafsofa-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/shine-schlafsofa-von-softline-mit-stoffen-von-kvadrat",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/couchtische/pori-holztisch-mit-schwarzen-metallfuessen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/sofaplus-de/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/edelber/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/swiss-plus/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kvadrat/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/softline/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/sofaplus-be/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/serviceleistungen/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/franz-fertig/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/sofaplus-dk/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-de/meterware-sofaplus-de/meterware-stoff-tara-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/innovation/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-de/konstanz-deluxe-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/konstanz-deluxe-schlafsofa-mit-lattenrost-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/hermod-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/hermod-schlafsofa-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/clubber-schlafsofa-und-sessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/clubber-schlafsofa-mit-und-ohne-armlehnen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/eckschlafsofa/mit-gaestebettfunktion/clubber-sessel-mit-und-ohne-armlehnen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/otris-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/otris-von-innovation-schlafsofa-mit-polsterarmlehnen-und-bettkasten",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/walis-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/walis-von-innovation-schlafsofa-mit-bettkasten",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/ramone-schlafsofa-und-schlafsessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/mit-gaestebettfunktion/ramone-klappsessel-90-von-innovation-in-diversen-stoffen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/cubed-02-schlafsofa-und-schlafsessel/ramone-schlafsofa-140-von-innovation-in-diversen-stoffen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/cubed-02-schlafsofa-und-schlafsessel/ramone-schlafsofa-160-von-innovation-in-diversen-stoffen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/ample-schlafsofa-und-sessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/ample-schlafsofa-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/ample-schlafsofa-mit-armlehnen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/ample-frej-schlafsofa-mit-holzarmlehnen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/eckschlafsofa/mit-gaestebettfunktion/ample-klappsessel-auch-mit-frej-holzarmlehnen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/napper-liege/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/liegen-und-daybeds/mit-gaestebettfunktion/napper-daybed-von-innovation-diverse-stoffe",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-dk/pori-holztisch/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-de/linz-deluxe-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/linz-deluxe-schlafsofa-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-de/stralsund-deluxe-bettsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/stralsund-deluxe-bettsofa-mit-lattenrost-und-matratze-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/stralsund-deluxe-hocker-mit-rollen-und-stauraum-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/stralsund-deluxe-sessel-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/aarhus-2-sitzer-designer-sofa-mit-holzarmlehnen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/aarhus-3-sitzer-designer-sofa-mit-holzarmlehnen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-dk/aarhus-zwei-und-dreisitzer/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/arendal-3-sitzer-designer-sofa-mit-breiten-polsterarmlehnen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/arendal-2-5-sitzer-designer-sofa-mit-breiten-polsterarmlehnen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-dk/arendal-sofas-2-5-und-dreisitzer/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/grimstad-hocker-mit-grosser-stoffauswahl",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/grimstad-designer-sessel-mit-polsterarmlehnen-hellen-holzfuessen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/grimstad-2-sitzer-designer-sofa-mit-polsterarmlehnen-hellen-holzfuessen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/grimstad-3-sitzer-designer-sofa-mit-polsterarmlehnen-hellen-holzfuessen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-dk/grimstad-sofas-sessel-und-hocker/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/lund-3-sitzer-designer-sofa-mit-polsterarmlehnen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-funktion/lund-2-sitzer-designer-sofa-mit-polsterarmlehnen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-dk/lund-sofas-zwei-und-dreisitzer/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/cassius-deluxe-quilt-wood-schlafsofa-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/cassius-deluxe-quilt-wood-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/malou-schlafsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/vip-schlafsofa-in-echtleder-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/vela-schlafsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/letto-schlafsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/riga-schlafsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/minnie-schlafsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/confetto-schlafsofa-bigsofa-von-franz-fertig",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/club-schlafsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/club-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/confetto-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/letto-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/malou-schlafsofa-schlafsessel-und-hocker/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/minnie-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/riga-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/taipei-winkelsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/vela-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/vip-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/dresden-hocker-mit-grosser-stoff-und-lederauswahl",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/minnie-hocker-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/mit-gaestebettfunktion/minnie-schlafsessel-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/fino-relaxsessel-von-franz-fertig-gestell-rundrohr",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/fino-relaxsessel-von-franz-fertig-gestell-flachstahl",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/dresden-sessel-mit-holzarmlehnen-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/dresden-sessel-und-hocker/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/fino-relaxsessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/modulsofa-und-bigsofa/confetto-ecksofa-eckschlafsofa-von-franz-fertig",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/modulsofa-und-bigsofa/club-eckschlafsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/taipei-winkelsofa-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/kissen/kissen-von-franz-fertig-die-collection",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/kissen-von-franz-fertig/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/franz-fertig/topper-matratzenschoner/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/matratzen-topper-fuer-schlafsofas/topper-matratzenschoner-in-diversen-groessen-von-franz-fertig",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-de/nuernberg-deluxe-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-de/erfurt-deluxe-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-de/dortmund-deluxe-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-de/innsbruck-deluxe-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/nuernberg-deluxe-schlafsofa-mit-lattenrost-und-matratze-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/nuernberg-deluxe-sessel-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/nuernberg-deluxe-hocker-mit-stauraum-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/dortmund-deluxe-schlafsofa-mit-lattenrost-und-matratze-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/erfurt-deluxe-schlafsofa-mit-bettkasten-und-topper-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/oldschool-sofa-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/eckschlafsofa/mit-gaestebettfunktion/oldschool-sessel-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/oldschool-schlafsofa-und-sessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/vithus-schlafsofa-bettsofa-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/vithus-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/achillas-schlafsofa-von-innovation-mit-bettkasten-und-2-x-80x200-cm-bett",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/achillas-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/revivus-schlafsofa-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/revivus-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/salla-schlafsofa-mit-polsterarmlehnen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/salla-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/accordion-faltmatratze-matratze-fuer-kinder-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/accordion-faltmatratze/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/innsbruck-deluxe-bettsofa-mit-verstellbarem-lattenrost-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/doppio-doppelliege-von-swiss-plus-schlafsofa-mit-schnellerer-lieferung",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/kopenhagen-oak-designer-sessel-mit-armlehnen-aus-eichenholz",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-bettfunktion/kopenhagen-oak-2-sitzer-designer-sofa-mit-armlehnen-aus-eichenholz",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-bettfunktion/kopenhagen-oak-3-sitzer-designer-sofa-mit-armlehnen-aus-eichenholz",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-bettfunktion/vaasa-2-5-sitzer-designer-sofa-mit-polsterarmlehnen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/eckschlafsofa/grosses-und-kleines-ecksofa/varberg-2-sitzer-l-sofa-mit-longchair-und-polsterarmlehnen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/eckschlafsofa/grosses-und-kleines-ecksofa/varberg-1-sitzer-sofa-mit-longchair-als-kleines-ecksofa",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/malmoe-designer-sessel-mit-polsterarmlehnen-und-versteppten-rueckenkissen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-bettfunktion/malmoe-2-sitzer-designer-sofa-mit-polsterarmlehnen-und-versteppten-rueckenkissen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/sofas-ohne-bettfunktion/malmoe-3-sitzer-designer-sofa-mit-polsterarmlehnen-und-versteppten-rueckenkissen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/swiss-plus/duetto-deluxe-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/duetto-deluxe-schlafsofa-bigsofa-mit-lattenrost-von-swiss-plus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-dk/vaasa-sofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-dk/varberg-ecksofas-ein-und-zweisitzer/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-dk/malmoe-sofas-und-sessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/eckschlafsofa/mit-gaestebettfunktion/zuerich-deluxe-eckschlafsofa-mit-bettkasten-und-longchair-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/augsburg-deluxe-daybed-mit-lattenrost-und-bettkasten-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/sylt-deluxe-schlafsofa-im-landhausstil-mit-bettkasten-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/sylt-deluxe-sessel-mit-holzfuessen-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/sylt-deluxe-hockerbank-mit-stauraum-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/aachen-deluxe-recamiere-mit-doppelbett-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-it/tesla-elektrisches-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-it/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/tesla-elektrisches-schlafsofa-bettsofa-mit-motor-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/koeln-deluxe-schlafsofa-mit-bettkasten-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/rosenheim-deluxe-einzelliege-oder-doppelbett-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/heide-deluxe-daybed-mit-lattenrost-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/liegen-und-daybeds/mit-gaestebettfunktion/bamberg-deluxe-einzelliege-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/salzburg-deluxe-daybed-mit-lattenrost-und-bettkasten-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/leipzig-deluxe-schlafsofa-mit-bettkasten-und-lattenrost-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/eckschlafsofa/mit-gaestebettfunktion/berlin-deluxe-ecksofa-mit-schlaffunktion-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-de/koeln-deluxe-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sofakissen/circle-runde-kissen-von-innovation-in-verschiedenen-stoffen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/koblenz-deluxe-einzelliege-mit-bettkasten-oder-doppelbett-schlafsofa-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/eluma-deluxe-button-schlafsofa-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/vogan-schlafsofa-/-vogan-lounger-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/sitzhocker-und-sitzsaecke/triangular-sitzhocker-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/aachen-deluxe-schlafsofa-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/bettsofa-fuer-jeden-tag/mannheim-deluxe-schlafsofa-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-de/mannheim-deluxe-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-de/aachen-deluxe-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/designersessel/ribe-designer-stuhl-mit-holzarmlehnen-und-lederbezug",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-dk/ribe-stuhl/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/modulsofa-konfigurator-von-tenksom-arthon-und-tokey",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/tenksom/arthon-sofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/tenksom/tokey-sofa-/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsessel/mit-gaestebettfunktion/cosial-schlafsessel-80-mit-armlehnen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/cosial-schlafsofa-140-mit-armlehnen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/cosial-schlafsofa-160-mit-armlehnen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/cosial-schlafsofa-180-mit-armlehnen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/cosial-schlafsofa-und-schlafsessel/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/eluma-deluxe-button-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/conlix-schlafsofa-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/conlix-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/conlix-patchwork-schlafsofa-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/pascala-schlafsofa-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/pascala-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/vanadis-schlafsofa-von-innovation-mit-bettkasten",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/vanadis-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/narvi-schlafsofa-mit-eichenholz-armlehnen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/narvi-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/frode-schlafsofa-von-innovation-mit-und-ohne-armlehnen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/frode-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/couchtische/storage-couchtisch-mit-stauraum-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/storage-beistelltisch-mit-stauraum/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/bragi-eckschlafsofa-mit-armlehnen-oder-seitentisch-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/bragi-eckschlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/nordham-schlafsofa-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/nordham-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/couchtische/grids-holztisch-in-schwarz-oder-eiche-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/grids-couchtisch/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/couchtische/laser-beistelltisch-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/laser-beistelltisch/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/couchtische/marmor-couchtisch-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/marmor-beistelltisch/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/skater-schlafsofa-konfigurator-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/skater-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/merga-schlafsofa-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/merga-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kleinmoebel-und-zubehoer/couchtische/stylo-holztisch-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/stylo-beistelltisch/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/tripi-von-innovation-schlafsofa-mit-polsterarmlehnen-und-bettkasten",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/tripi-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-de/meterware-sofaplus-de/meterware-kunstleder-rica-von-sofaplus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/showrooms/hamburg/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/showrooms/berlin/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/kontakt",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/datenschutz",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/allgemeine-geschaeftsbedingungen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/widerrufsrecht-widerrufsfolgen",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/impressum",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/liefer-und-versandkosten",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/jobs",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/zahlungsmoeglichkeiten",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/sicheres-einkaufen-und-retoureninfo",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/stoffprobenanfrage",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/bekannt-aus",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/newsletter",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/gutschein-rabatt-aktion",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/sofaplus-be/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/splitback-schlafsofa-mit-frej-und-lauge-holzarmlehnen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/schlafsofa/mit-gaestebettfunktion/dublexo-schlafsofa-mit-frej-und-lauge-holzarmlehnen-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/softline/madison-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/LOUNGE-PLUS-Chaiselongue-von-Softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/LOUNGE-PLUS-Eckschlafsofa-von-Softline",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/hersteller/innovation/mimer-schlafsofa/",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/eckschlafsofa/mit-gaestebettfunktion/splitback-schlafsessel-von-innovation",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  },
  {
    name: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQMeta?.name,
    path: "/.well-known/appspecific/:pathMatch(.*)",
    component: component_45stubB5vZ5K8V_452knzcEofJHjjeE_45bvS8X6wSqJB5EdMvVTQ
  }
]